import {Injectable} from '@angular/core';
import {CurationPanels} from '../components/curation-dashboard/curation-setting';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';

@Injectable()
export class NodesPlaceViewCalculationsService {

  private _shiftFromRightPanel: number = 32;
  private shiftModelerSystem: number = 6; //+ 6 pix difference due to modeler axe system place
  private _defaultRightPanelWidth: number = 518;
  private rightPanelWidth: number = 0; // 41rem
  private rightPanelOpened: boolean = false;

  get defaultRightPanelWidth(): number {
    return this._defaultRightPanelWidth;
  }

  set defaultRightPanelWidth(value: number) {
    this._defaultRightPanelWidth = value;
  }

  get shiftFromRightPanel(): number {
    return this._shiftFromRightPanel;
  }

  set shiftFromRightPanel(value: number) {
    this._shiftFromRightPanel = value;
  }

  public getXOffsetForHeadNode(distanceFromPanelPix: number) {
    const modelerWidth = this.getElementWidth('js-canvas');
    const explorerPanelWidth = this.getElementWidth(CurationPanels.explorerViewPanel);
    const treeViewIconContainerWidth = this.getElementWidth(CurationPanels.treeViewIconContainer);
    return modelerWidth - (explorerPanelWidth + treeViewIconContainerWidth + distanceFromPanelPix + this.shiftModelerSystem);
  }

  public getXOffsetForHeadNode1(distanceFromPanelPix: number) {
    const modelerWidth = this.getElementWidth('js-canvas');
    const explorerPanelWidth = this.getElementWidth(CurationPanels.explorerViewPanel);
    return modelerWidth - (explorerPanelWidth + distanceFromPanelPix + this.shiftModelerSystem);
  }

  public getXOffsetForTreatmentNode(distanceFromPanelPix: number, takeRightPanelInAccount: boolean = false) {
    this.rightPanelWidth = this.rightPanelOpened ? this.getRightPanelWidth() : (takeRightPanelInAccount ? this._defaultRightPanelWidth : 0);
    return this.rightPanelWidth + distanceFromPanelPix + this.shiftModelerSystem;
  }

  public getElementWidth(elementId: string) {
    const htmlElement = document.getElementById(elementId);
    if (htmlElement?.offsetWidth !== 0) {
      return htmlElement?.offsetWidth;
    }
    return 0;
  }

  public getRightPanelWidth() {
    const rightPanelElement = document.getElementById(CurationPanels.rightPanel);
    if (this.rightPanelWidth === 0 && rightPanelElement?.offsetWidth !== 0) {
      return rightPanelElement?.offsetWidth;
    }
    return this.rightPanelWidth;
  }

  public updateRightPanelWidth() {
    const rightPanelElement = document.getElementById(CurationPanels.rightPanel);
    if (rightPanelElement?.offsetWidth !== 0) {
      this.rightPanelWidth = rightPanelElement?.offsetWidth;
    }
  }

  public getNumericNodeType(bpmnType: string): NodeType {
    switch (bpmnType) {
      case 'bpmn:SubProcess':
        return NodeType.neighborhood_head;
      default:
        return NodeType.normal;
    }
  }

  setRightPanelState(display: boolean) {
    this.rightPanelOpened = display;
  }

  public calculateShiftData(takeRightPanelInAccount: boolean = true) {
    const data = {
      X: this.getXOffsetForTreatmentNode(this._shiftFromRightPanel, takeRightPanelInAccount),
      Y: 0, shift: 'fromRight'
    };
    return data;
  }
}
